import { lazy } from "react";

import { AdminLayout } from "../layouts/AdminLayout";
import RutaProtegida from "@components/RutaProtegida";
import { BajoConstruccion } from "@components/BajoConstruccion";

const Usuarios = lazy(() => import("../subFeatures/Usuarios/pages/Usuarios"));
const Companias = lazy(() => import("../components/sections/Companias"));
const Financieras = lazy(() => import("../components/sections/Financieras"));
const RolesPermisos = lazy(() => import("../components/sections/RolesPermisos"));
const General = lazy(() => import("../components/sections/General/pages/General"));
const ReglasAdmision = lazy(() => import("../components/sections/ReglasAdmision"));
const CodigosAtribucionV2 = lazy(() => import("../components/sections/CodigosAtribucionV2"));
const EstructuraAtribucion = lazy(() => import("../components/sections/EstructuraAtribucion"));
const Solicitudes = lazy(() => import("../components/sections/Solicitudes/pages/Solicitudes"));
const ReglasAdmisionFinancieras = lazy(() => import("../components/sections/ReglasAdmisionFinancieras"));
const EncargadosEtapa = lazy(() => import("../components/sections/EncargadosEtapa"));

export const adminRoutes = {
    element: <RutaProtegida permissionCodes={["MADMIN"]} />,
    children: [
        {
            Component: AdminLayout,
            path: "/admin",
            children: [
                // {
                //     index: true,
                //     Component: <></>,
                //     loader: ({ request }) => {
                //         const url = new URL(request.url);
                //         if (/^\/(?:solicitudes|admin)\/$/.test(url.pathname)) {
                //             return redirect(url.pathname.replace(/\/+$/, ""));
                //         }
                //     },
                // },
                {
                    Component: Usuarios,
                    path: "usuarios",
                },
                {
                    Component: RolesPermisos,
                    path: "roles",
                },
                {
                    Component: Companias,
                    path: "companias",
                },
                {
                    Component: Financieras,
                    path: "financieras",
                },
                {
                    Component: CodigosAtribucionV2,
                    path: "codigos_atribucion",
                },
                {
                    Component: EstructuraAtribucion,
                    path: "estructura_atribucion",
                },
                {
                    Component: ReglasAdmision,
                    path: "abortivos_revision",
                },
                {
                    Component: ReglasAdmisionFinancieras,
                    path: "abortivos_revision_financieras",
                },
                {
                    Component: BajoConstruccion,
                    path: "log_actividad",
                },
                {
                    Component: General,
                    path: "general",
                },
                {
                    Component: Solicitudes,
                    path: "solicitudes",
                },
                {
                    Component: EncargadosEtapa,
                    path: "encargados_etapa",
                },
            ],
        },
    ],
};
